import React from 'react';

import { InfoPage } from 'components/common/Layout/InfoPage/InfoPage';
import BaseLayoutPromo from 'components/no-auth/common/BaseLayoutPromo';
import LibreNoAuthInfo from 'components/no-auth/info/LibreNoAuthInfo';

import { LANDING_LINK } from 'constants/UrlConstants';

import { resolveArguments } from 'helpers/utils';

import { useExtra } from 'hooks/selectors';

const LibreNoAuthChequePage = (props) => {
    const { strapiApi } = useExtra();

    if (strapiApi?.paymentInfo) {
        return <LibreNoAuthInfo renderOptions={props.renderOptions} paymentInfo={strapiApi.paymentInfo} />;
    } else
        return (
            <BaseLayoutPromo>
                <InfoPage
                    animatedIconFail
                    mainText={resolveArguments(strapiApi?.errorPageText, strapiApi?.alias)}
                    primaryButtonCaption={strapiApi?.errorPageButtonCaption}
                    primaryButtonType="link"
                    primaryButtonLink={LANDING_LINK}
                />
            </BaseLayoutPromo>
        );
};

export default LibreNoAuthChequePage;
